module.exports = ".pagination {\n  margin: 0px;\n  margin-left: 10px;\n  vertical-align: middle;\n}\n\n.pagination li > a {\n  cursor: pointer;\n}\n"